import ApiService from './ApiService';

export default class NewsApi extends ApiService {
    constructor() {
        super('news');
    }

    getAllNews(payload) {
        return this.get('', payload);
    }

    getNewsDetail(code) {
        return this.get(code);
    }

    createNews(payload) {
        return this.post('', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    }

    updateNews(payload) {
        const { code, data } = payload;
        return this.put(code, data, { headers: { 'Content-Type': 'multipart/form-data' } });
    }

    updateNewsStatus(payload) {
        const { code, status } = payload;
        return this.put(`status/${code}`, { status });
    }

    deleteNews(code) {
        return this.delete(code);
    }
}
